export default "__VITE_ASSET__b6c3a8a0__$_?component__"